import React from 'react';
import {Link} from 'gatsby';
import Img from 'gatsby-image';
import {useCategories} from '../../query/useCategories';

import styles from './styles.module.css';

const CategoriesBlock = () => {
  const {categories} = useCategories();
  return (
    <div className={styles.categories}>
      {categories.edges.map(({node}) => {
        const {productsCategorie} = node;

        // display only if has product
        if (productsCategorie === null || productsCategorie.length === 0) {
          return null;
        }
        const {slug} = node.fields;
        const {title, description, image} = node.frontmatter;
        return (
          <div key={slug} className={styles.categorie}>
            <div className={styles.categorie_image}>
              <div>
                <Img fluid={image.childImageSharp.fluid} alt={title} />
              </div>
            </div>
            <div className={styles.categorie_info}>
              <Link to={slug}>{title}</Link>
              <p>{description}</p>
              <button>Découvrir les {title}</button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CategoriesBlock;
